@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/greys';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/text';
@forward '@raspberrypifoundation/design-system-core/scss/properties/colors/brand';
@forward '@raspberrypifoundation/design-system-core/scss/properties/spacing';
@forward '@raspberrypifoundation/design-system-core/scss/properties/border';
@forward '@raspberrypifoundation/design-system-core/scss/properties/font-size';
@forward '../../global/styles';

:host {
  --nav-background: var(--rpf-white);
  --text-color: var(--rpf-text-primary);
  --slot-divider: var(--rpf-grey-150-50);
  --focus-border-color: var(--rpf-brand-raspberry);
  --transparent-black-100: hsl(0deg 0% 0% / 10%);
  --transparent-black-200: hsl(0deg 0% 0% / 20%);
  --button-font-size: var(--font-size-1);

  position: relative;
  z-index: 9999;
}

:host([theme='dark']) {
  --nav-background: var(--rpf-grey-850);
  --text-color: var(--rpf-text-primary-darkmode);
  --focus-border-color: var(--rpf-white);
}

:host([theme='clear']) {
  --nav-background: transparent;
  --text-color: var(--rpf-text-primary-darkmode);
  --focus-border-color: var(--rpf-white);
  --slot-divider: var(--rpf-grey-150-50);
}

.rpf-global-nav {
  align-items: center;
  background: var(--nav-background);
  container-type: inline-size;
  display: flex;
  justify-content: space-between;
  padding-block: var(--space-0-5);
  padding-inline-end: var(--space-1);
  padding-inline-start: var(--space-2);
  position: relative;

  a {
    &:focus-visible {
      border-radius: var(--border-radius);
      outline: 2px solid var(--focus-border-color);
    }
  }

  &__slot {
    align-items: center;
    display: flex;

    > *:not(:last-child) {
      border-inline-end: var(--border-width-sm) solid var(--slot-divider);
    }
  }
}
